module.exports = __webpack_public_path__ + "static/media/pytorch.5f2b7688.svg";